import React, { useState, useEffect } from "react";
import TeacherMenu from "../TeacherMenu/TeacherMenu";
import Overview from "../Overview/Overview";
import Student from "../Student/Student";
import Attendance from "../Attendance/Attendance";
import Assignmentpage from "../Assignmentpage/Assignmentpage";
import AttendanceReport from "../AttendanceReport/AttendanceReport";
import AssignmentReport from "../AssignmentReport/AssignmentReport";
import MainReport from "../ResultsReport/MainReport"; // ✅ Import MainReport.jsx instead
import { FaBars } from "react-icons/fa";
import "./TeacherDashboard.css";

const TeacherDashboard = () => {
  const [selectedMenu, setSelectedMenu] = useState(() => {
    return localStorage.getItem("teacherSelectedMenu") || "Dashboard";
  });
  const [isOpen, setIsOpen] = useState(true);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleMenuClick = (menu) => {
    setSelectedMenu(menu);
    localStorage.setItem("teacherSelectedMenu", menu);
  };

  // Load saved menu on mount
  useEffect(() => {
    const saved = localStorage.getItem("teacherSelectedMenu");
    if (saved && saved !== selectedMenu) {
      setSelectedMenu(saved);
    }
  }, [selectedMenu]);

  // Mobile back button protection
  useEffect(() => {
    const handlePopState = (e) => {
      const loggedIn = !!localStorage.getItem("teacher_logged_in");
      if (!loggedIn) {
        window.location.href = "/login"; // only go to login if actually logged out
      } else {
        // Stay on dashboard, restore last selected menu
        const lastMenu = localStorage.getItem("teacherSelectedMenu") || "Dashboard";
        setSelectedMenu(lastMenu);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    <div className="teacher-dashboard-container" style={{ display: "flex" }}>
      {/* Menu toggle button */}
      <button
        className="teacher-menu-toggle-btn-outside"
        onClick={toggleMenu}
        aria-label={isOpen ? "Collapse menu" : "Expand menu"}
        style={{
          position: "fixed",
          bottom: 10,
          left: 10,
          zIndex: 1000,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: "24px",
          color: "#333",
        }}
      >
        <FaBars />
      </button>

      {/* Sidebar menu */}
      <div className={`teacher-menu ${isOpen ? "open" : "collapsed"}`} style={{ transition: "width 0.3s ease" }}>
        <TeacherMenu onMenuClick={handleMenuClick} isOpen={isOpen} toggleMenu={toggleMenu} />
      </div>

      {/* Main content */}
      <div className="teacher-main-content">
        {selectedMenu === "Dashboard" && <Overview isMenuOpen={isOpen} />}
        {selectedMenu === "Student List" && <Student />}
        {selectedMenu === "Attendance" && <Attendance />}
        {selectedMenu === "Assignments" && <Assignmentpage />}
        {selectedMenu === "Attendance Report" && <AttendanceReport />}
        {selectedMenu === "Assignment Report" && <AssignmentReport />}
        {selectedMenu === "Results Report" && (
          <MainReport onBack={() => handleMenuClick("Dashboard")} />
        )}
      </div>
    </div>
  );
};

export default TeacherDashboard;
